import React, { useState } from 'react';
import Modal from '../../Components/Modal';
import Form, { TextField, TextArea, Actions, ULID, Money, Services, Frequency, RequiredValidator, Round, Duration, ScheduleConstraints, Switch, ItemisationAdjustment, Tags } from '../../Components/Form';
import { useCustomer } from '../../Data/Customers';
import { useSession } from '../../Components/Session';

const EditJob = ({job, onClose, then}) => {
    return <Modal title={job?.id ? 'Edit job' : 'Add job'} isOpen={!!job} setIsOpen={onClose} dismissible>
        {job && <Inner {...{job, then}} />}
    </Modal>
}

const Inner = ({job, then}) => {
    const {updateJob} = useCustomer(job.customerId);
    const {hasFeature} = useSession();
    const [cost, setCost] = useState(job.cost);

    return <Form onSubmit={(data) => updateJob(job.id, data)} data={job} afterSubmit={then} closeModalOnSubmit>
        <TextField name="title" label="Title" />
        <Services name="services" label="Service" validators={[RequiredValidator]} showAddService />
        <Frequency name="frequency" label="Frequency" />
        {hasFeature('ADVANCED_SCHEDULING') && <ScheduleConstraints name="scheduleConstraints" label="Advanced Scheduling" />}
        {!hasFeature('ADVANCED_SCHEDULING') && <Switch label="Advanced Scheduling"
            help="Advanced Scheduling is not available on your current plan"
            disabled={true}
        />}
        <Round name="roundId" label="Round" coordinates={job.coordinates} addRound />
        <Money name="cost"
            label="Cost"
            disabled={job.id}
            onChange={setCost}
            help={job.id ?
                'To change the cost of this job update the cost breakdown using the \'Edit cost\' option.' :
                'A cost breakdown will be created for this job which you can edit in detail once the job is added.'
            }
        />

        <ItemisationAdjustment originalCost={cost}
            help={job.id ?
                    'Adjust the cost the next time this job is billed.' :
                    'Adjust the cost of this job the first time it\'s billed.'
                }
        />

        <Duration name="duration" label="Duration" />
        <TextArea label="Notes" name="notes" />
        <Tags name="tags" label="Tags" />
        <ULID name="jobId" />
        <Actions submit cancel />
    </Form>;
}

export default EditJob;
